import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { capitaliseFirstLetter } from '../../../functions/capitalise-first-letter';

@Pipe({
  name: 'capitalizeFirstLetter',
  standalone: true,
  pure: true,
})
@Injectable({ providedIn: 'root' })
export class CapitalizeFirstLetterPipe implements PipeTransform {
  transform(value: string): string {
    return capitaliseFirstLetter(value);
  }
}
